import React from 'react';
import { ExceptionQueueTable } from '../components/ExceptionQueueTable';

export function FollowUpsPage() {
  return (
    <ExceptionQueueTable
      title="Follow Ups"
      subtitle="Received-Short tickets waiting on a reorder batch"
      blurb="When the new batch arrives, open the ticket and merge it in."
      predicate={r => r.material_status === 'Follow Ups'}
      stageKey="follow-ups"
    />
  );
}
